










import { Component, Vue, Prop } from 'vue-property-decorator'
import FriendList from '@/components/FriendList.vue'

@Component({
  components: {
    FriendList
  }
})
export default class SolveView extends Vue {}
